import { OrderDocumentValidationStatus } from 'src/types/enums';
import { Pill } from '../../../components/pill/Pill';
import { useTranslation } from '../../../contexts/translation-context';
import {
  OrderDocumentValidationStatusToColor,
  OrderDocumentValidationStatusToTranslationKey,
} from '../utils/document-validation';

export interface IOrderDocumentValidationBadgeProps {
  status: OrderDocumentValidationStatus;
}

export const OrderDocumentValidationBadge: React.FC<IOrderDocumentValidationBadgeProps> = ({ status }) => {
  const { i18n } = useTranslation();

  return (
    <Pill color={OrderDocumentValidationStatusToColor[status]} size="sm">
      {i18n(OrderDocumentValidationStatusToTranslationKey[status])}
    </Pill>
  );
};
